<template>
    <div>
        <div class="finNestedTab">
            <ul class="tabs nav nav-tabs" id="myTab">
                <li class="nav-item" v-for="tab in tabs" @click.prevent="setActiveTabName(tab.name)">
                    <a class="nav-link" href="#" v-bind:class="(tab.name == activeTabName)?'active':''">{{ tab.displayName }}</a>
                </li>
            </ul>
            <div class="tab_container tab-content hideMob-t" id="myTabContent">
                                        <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                                        <h3 class="d_active tab_drawer_heading" rel="tab1" @click.prevent="setActiveTabName('overview')" v-bind:class="(activeTabName == 'overview')?'active':''">Equity</h3>
                                        <div id="tab1" class="tab_content" v-if="(activeTabName == 'overview')">
                                             <div class="calc_form">                        
                                                <div class="customcheckbox text-center mb-3">
                                                    <label class="form-check-label" for="equityId">
                                                        <input class="form-check-input" type="radio" v-model="equity_cal" id="equityId" value="equity">
                                                        <span class="checkmark"></span> Intraday
                                                    </label>
                                                    <label class="form-check-label" for="deliveryId">
                                                        <input class="form-check-input" type="radio" v-model="equity_cal" id="deliveryId" value="delivery">
                                                        <span class="checkmark"></span> Delivery
                                                    </label>
                                                </div>                        
                                                <app-BrokerageInputs :calculatorType="'equity'" :operationType="equity_cal">
                                                    
                                                </app-BrokerageInputs>
                                            </div>
                                        </div>
                                        </div>
                                        <!-- #tab1 -->
                                        <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                                        <h3 class="tab_drawer_heading" rel="tab2" @click.prevent="setActiveTabName('about')" v-bind:class="(activeTabName == 'about')?'active':''">F & O</h3>
                                        <div id="tab2" class="tab_content" v-if="(activeTabName == 'about')">
                                            <div class="calc_form">
                                                <div class="customcheckbox text-center mb-3">
                                                    <label class="form-check-label" for="futuresId">
                                                        <input class="form-check-input" type="radio" v-model="fo_cal" id="futuresId" value="futures">
                                                        <span class="checkmark"></span> Futures
                                                    </label>
                                                    <label class="form-check-label" for="optionsId">
                                                        <input class="form-check-input" type="radio" v-model="fo_cal" id="optionsId" value="options">
                                                        <span class="checkmark"></span> Options
                                                    </label>
                                                </div>
                                                <app-BrokerageInputs :calculatorType="'fo'" :operationType="fo_cal"></app-BrokerageInputs>
                                            </div>
                                        </div>
                                       </div>
                                        <!-- #tab2 -->
                                        <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                                        <h3 class="tab_drawer_heading" rel="tab3" @click.prevent="setActiveTabName('check')" v-bind:class="(activeTabName == 'check')?'active':''">Currency</h3>
                                        <div id="tab3" class="tab_content" v-if="(activeTabName == 'check')">
                                       <div class="calc_form">                        
                                        <div class="customcheckbox text-center mb-3">
                                            <label class="form-check-label" for="futuresCdsId">
                                                <input class="form-check-input" type="radio" v-model="cds_cal" id="futuresCdsId" value="futures">
                                                <span class="checkmark"></span> Futures
                                            </label>
                                            <label class="form-check-label" for="optionsCdsId">
                                                <input class="form-check-input" type="radio" v-model="cds_cal" id="optionsCdsId" value="options">
                                                <span class="checkmark"></span> Options
                                            </label>
                                        </div>
                                        <app-BrokerageInputs :calculatorType="'cds'" :operationType="cds_cal"></app-BrokerageInputs>
                                    </div> 
                                        </div>
                                        </div>
                                        <!-- #tab3 -->
                                        <div class="tab-pane fade show active" id="t1" role="tabpanel" aria-labelledby="t1-tab">
                                        <h3 class="tab_drawer_heading" rel="tab4" @click.prevent="setActiveTabName('fin')" v-bind:class="(activeTabName == 'fin')?'active':''">Commodities</h3>
                                        <div id="tab4" class="tab_content" v-if="(activeTabName == 'fin')">
                                           <div class="calc_form">                        
                                            <div class="customcheckbox text-center mb-3">
                                                <label class="form-check-label" for="mcxId">
                                                    <input class="form-check-input" type="radio" v-model="mcx_cal" id="mcxId" value="mcx" checked="checked">
                                                    <span class="checkmark"></span> Futures
                                                </label>
                                                <label class="form-check-label" for="mcxId1">
                                                    <input class="form-check-input" type="radio" v-model="mcx_cal" id="mcxId1" value="options" checked="checked">
                                                    <span class="checkmark"></span> Options
                                                </label>
                                            </div>
                                            <app-BrokerageInputs :calculatorType="'mcx'" :operationType="mcx_cal" ></app-BrokerageInputs>
                                        </div>
                                        </div>
                                      </div>
                                    </div>
        </div>                           

    </div>
</template>


<script>
    
    import brokerageInputs from '../calculators/brokerage/brokerage_inputs'
    import VueFaqAccordion from 'vue-faq-accordion'
    export default {
        name: 'calculator',
        data(){
            return {                                
                "equity_cal" : "equity",
                "fo_cal" : "futures",
                "cds_cal" : "futures",
                "mcx_cal" : "mcx",
                 tabs: [
                    {
                    name: 'overview',
                    displayName: 'Equity',
                    },
                    {
                    name: 'about',
                    displayName: 'F & O',
                    },
                    {
                    name: 'check',
                    displayName: 'Currency',
                    },
                    {
                    name: 'fin',
                    displayName: 'Commodities',
                    }
                ],
                activeTabName: null,
            }
        },
        components: { 
            VueFaqAccordion,           
            appBrokerageInputs: brokerageInputs            
        },
        watch:{
            mcx_cal(mcx_value){
            
                if(this.activeTabName == 'fin'){
                    this.$emit('commodities', mcx_value);
                }
                else{
                    this.$emit('commodities', '0');
                }
            }, 
            activeTabName(aTN){
                if(aTN === 'fin'){

                    this.$emit('commodities', this.mcx_cal);
                }  else{
                    this.$emit('commodities', '0');
                }
            }
        },
       methods: {   
            setActiveTabName(name) {
                this.activeTabName = name;
           
            },
           
        },
        mounted() {
            this.activeTabName = this.tabs[0].name;
            window.scroll(0,0)
        },
        created(){
            if(this.activeTabName == 'Fin'){
                this.$emit('commodities', this.mcx_cal);
            }
            else{
                this.$emit('commodities', '0');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/website/shared/calculators/brokerage.vue